<template>
  <div class="fill">
    <div
      :offset-top="0"
      style="z-index: 100001;border-bottom: 1px solid #dcdcdc;"
    >
      <div id="editor__header"></div>
    </div>
    <div id="editor__body"></div>
    <!--新增表格-->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="tableMode === 'ADD' ? '插入表格' : '编辑表格'"
      :visible.sync="dialogTableVisible"
      width="600px"
    >
      <el-table
        :data="tableData"
        border
        row-key="rowKey"
        style="width: 100%"
      >
        <el-table-column label="">
          <template slot="header">
            <input
              v-model="tableHeader"
              placeholder="自定义标题"
              class="table_header__input"
            />
          </template>
          <template #default="scope">
            <div class="flex flex1 justify-between items-center">
              <div class="table-cell flex1">
                <el-input
                  v-model="scope.row.key"
                  placeholder="自定义字段"
                  size="medium"
                ></el-input>
              </div>
              <div class="table-cell flex1">
                <el-input
                  v-model="scope.row.value"
                  placeholder="自定义内容"
                  size="medium"
                ></el-input>
              </div>

              <div class="table-cell table-cell__operate flex items-center">
                <img
                  alt="删除"
                  class="table-icon table-icon__remove"
                  src="../../assets/images/icon/icon-remove.svg"
                  @click="onRemoveTableRow(scope.$index)"
                />
                <el-switch
                  v-model="scope.row.show"
                  :active-text="scope.row.show ? '显示' : '隐藏'"
                  inactive-text=""
                >
                </el-switch>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 2em;text-align: right">
        <el-button
          plain
          size="small"
          type="primary"
          @click="onAddTableRow"
        >
          新增
        </el-button>
        <el-button
          size="small"
          type="primary"
          @click="onSaveTable"
        >
          保存
        </el-button>
      </div>
    </el-dialog>
    <!--图片上传-->
    <el-dialog
      id="image-uploader"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :multiple="true"
      :visible.sync="dialogImageVisible"
      list-type="picture"
      title="上传本地图片"
    >
      <div class="uploader__image">
        <el-upload
          :before-remove="onBeforeRemoveImage"
          :file-list="localImageList"
          :http-request="onUploadImage"
          :on-change="onChangeImage"
          :on-remove="onRemoveImage"
          :on-success="onUploadImageSuccess"
          accept="image/*"
          action=""
          list-type="picture-card"
          multiple
        >
          <i
            slot="default"
            class="el-icon-plus"
          ></i>
        </el-upload>
      </div>
      <div style="margin-top: 1em;text-align: right">
        <el-button
          :loading="showUploadLoading"
          size="small"
          type="primary"
          @click="onSaveImage"
        >
          保存
        </el-button>
      </div>
    </el-dialog>
    <!--文件上传-->
    <el-dialog
      id="file-uploader"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :multiple="true"
      :visible.sync="dialogFileVisible"
      list-type="picture"
      title="上传本地文件"
      width="600px"
    >
      <div
        v-loading="showUploadLoading"
        class="uploader__file flex"
        element-loading-text="正在上传中..."
        element-loading-spinner="el-icon-loading"
      >
        <el-upload
          :before-remove="onBeforeRemoveFile"
          :file-list="localFileList"
          :http-request="onUploadFile"
          :on-change="onChangeFile"
          :on-remove="onRemoveFile"
          action=""
          list-type="text"
          multiple
        >
          <el-button
            size="small"
            type="primary"
          >
            选择文件
          </el-button>
        </el-upload>
      </div>

      <div style="margin-top: 1em;text-align:right">
        <el-button
          size="small"
          type="primary"
          :loading="showUploadLoading"
          @click="onSaveFile"
        >
          保存
        </el-button>
      </div>
    </el-dialog>
    <!--视频上传-->
    <el-dialog
      id="video-uploader"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :multiple="false"
      :visible.sync="dialogVideoVisible"
      list-type="picture"
      title="上传本地视频"
      width="600px"
      :limit="1"
    >
      <div
        v-loading="showUploadLoading"
        class="uploader__file flex"
        element-loading-text="正在上传中..."
        element-loading-spinner="el-icon-loading"
      >
        <el-upload
          :before-upload="beforeUploadVideo"
          :before-remove="onBeforeRemoveFile"
          :file-list="localVideoList"
          :http-request="onUploadVideo"
          :on-change="onChangeVideo"
          :on-remove="onRemoveVideo"
          :on-progress="uploadVideoProcess"
          action=""
          list-type="text"
          multiple
        >
          <el-button
            size="small"
            type="primary"
          >
            选择视频
          </el-button>
        </el-upload>
      </div>

      <div style="margin-top: 1em;text-align:right">
        <el-button
					:loading="showUploadLoading"
          size="small"
          type="primary"
          @click="onSaveVideo"
        >
          保存
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapState, mapGetters, mapMutations } from 'vuex'
import WangEditor from 'wangeditor'
import { EventBus } from '@/js/event-bus'
import AddTable from '@/plugins/table.editor'
import AddImage from '@/plugins/image.editor'
import AddFile from '@/plugins/file.editor'
import AddVideo from '@/plugins/video.editor'
import QRCodeMixin from '@/mixin/qrcode.editor'
import tableMixin from '@/mixin/table.editor'
import imageMixin from '@/mixin/image.editor'
import fileMixin from '@/mixin/file.editor'
import videoMixin from '@/mixin/video.editor'

let _this = void 0

export default {
  name: 'Editor',
  components: {},
  filters: {},
  mixins: [QRCodeMixin, tableMixin, imageMixin, fileMixin, videoMixin],
  props: {},
  data() {
    return {
      // 光标所在的祖先节点
      rangeRoot: void 0,
      // 富文本编辑器对象
      editor: null,
      // 选中的自定义组件区域
      activeArea: void 0,
      // 选中的自定义组件区域id
      selectedAreaId: '',
      // 控制编辑表格的弹窗是否显示
      dialogTableVisible: false,
      // 自定义表格表头
      tableHeader: '',
      // 编辑表格的表格数据
      tableData: [],
      // 表格窗口操作模式
      tableMode: 'ADD',

      // 控制上传本地图片弹窗是否显示
      dialogImageVisible: false,
      //
      localImageList: [],
      // 控制上传文件的弹窗是否显示
      dialogFileVisible: false,
      localFileList: [],
      folderId: 0,
      // 控制上传本地视频弹窗是否显示
      dialogVideoVisible: false,
      localVideoList: [],
      showUploadLoading: false,
    }
  },
  computed: {
    ...mapState('editor', {
      QRCodeID: state => state.QRCodeID,
      editorStatus: state => state.editorStatus,
    }),
  },
  watch: {
    dialogImageVisible(state) {
      if (!state) {
        this.localImageList = []
      }
    },
    dialogFileVisible(state) {
      if (!state) {
        this.localFileList = []
      }
    },
    dialogVideoVisible(state) {
      if (!state) {
        this.localVideoList = []
      }
    },
  },
  created() {
    _this = this
  },
  mounted() {
    // 绑定外部事件
    EventBus.onShowTableEditor = this.onShowTableEditor
    EventBus.onShowImageEditor = this.onShowImageEditor
    EventBus.onShowFileEditor = this.onShowFileEditor
    EventBus.onShowVideoEditor = this.onShowVideoEditor

    // 创建编辑器对象
    this.editor = new WangEditor('#editor__header', '#editor__body')
    // 配置zIndex
    this.editor.config.zIndex = 10
    // 开启粘贴样式
    this.editor.config.pasteFilterStyle = true
    // 配置菜单和菜单项显示顺序
    this.editor.config.menus = [
      // 撤销
      // 'undo',
      // 重做
      //  'redo',
      // 字号
      'fontSize',
      // 粗体
      'bold',
      // 斜体
      'italic',
      // 下划线
      'underline',
      // 背景色
      'backColor',
      // H标题
      'head',
      // 字体
      'fontName',
      // 删除线
      // 'strikeThrough',
      // 缩进
      'indent',
      // 行高
      'lineHeight',
      // 写字笔颜色
      'foreColor',
      // 链接
      'link',
      // 列表
      'list',
      // 对齐方式
      'justify',
      // 引用
      'quote',
      // 表情包
      // 'emoticon',
      // 插入图片
      // 'image',
      // 插入视频
      // 'video',
      // 插入表格
      // 'table',
      // 插入代码
      // 'code',
      // 分割线
      // 'splitLine',
    ]

    // editor失焦事件监听
    this.editor.config.onblur = function onblurChange() {
      // console.log(_this.editor.txt.html())
    }
    // this.editor.config.onblur = function (newHtml) {
    // 	console.log('onblur', newHtml)
    // }
    // 监听变化
    this.editor.config.onchange = function onchange(html) {
      _this.$store.commit('editor/setEditorHtmlData', html)
    }
    // 注册插件
    this.initPlugins()
    // 生成编辑器
    this.editor.create()
    // 监听全局点击事件
    window.onclick = function monitorClick(e) {
      for (const elem of e.path.values()) {
        if (elem.className) {
          if (elem.className.includes('area__container')) {
            if (elem.className.includes('area__container--active')) {
              return
            }
            if (_this.activeArea) {
              _this.activeArea.className = 'area__container'
            }
            _this.activeArea = elem
            _this.selectedAreaId = elem.id
            elem.className += ' area__container--active'
            return
          }
        }
      }
      if (_this.activeArea) {
        _this.activeArea.className = 'area__container'
        _this.activeArea = void 0
      }
    }
    // 监听全局双击事件，（表格编辑功能）
    window.ondblclick = function monitorDblclick(e) {
      for (const item of e.path.values()) {
        if (item.className) {
          if (item.className.includes('area__container')) {
            if (item.className.includes('area__container--active')) {
              const isIncludesTable = item.getElementsByTagName('table').length
              if (isIncludesTable > 0) {
                _this.packageEvent(item, 'TABLE')
              }
            }
          }
        }
      }
    }
    // 监听富文本内容区键入事件
    document.getElementById('editor__body').onkeydown = function monitorOnkeydown(event) {
      if (event.key === 'Enter') {
        if (_this.activeArea) {
          const p = document.createElement('p')
          p.innerHTML = '<br/>'
          _this.beforeInsertElement(p)
        }
      }
    }

    if (this.editorStatus !== 'create') {
      this.loadData()
    }
  },
  beforeDestroy() {
    this.editor.destroy()
    this.editor = null
  },
  methods: {
    ...mapGetters('editor', ['getQrcodeId']),
    ...mapMutations('editor', ['setPosterTitle', 'setPosterData', 'setTemplate']),
    /*
     * 初始获取二维码数据
     * */
    async loadData() {
      const qrcodeId = this.getQrcodeId()
      const { success, data } = await this.$http({
        url: this.$api.getQRCodeDataDetail,
        params: {
          qrcodeID: qrcodeId,
        },
      })
      if (success) {
        const { HtmlData: htmlData, Name, FormData } = data
        this.editor.txt.html(htmlData)
        this.setPosterTitle(Name)
        this.setPosterData(JSON.parse(FormData).posterData)
        this.setTemplate(JSON.parse(FormData).templateName)
      }
    },
    /**
     * 注册富文本自定义菜单
     */
    initPlugins() {
      // 注册菜单
      this.editor.menus.extend('addImage', AddImage)
      this.editor.menus.extend('addTable', AddTable)
      this.editor.menus.extend('AddFile', AddFile)
      this.editor.menus.extend('AddVideo', AddVideo)
      // 将菜单加入到 editor.config.menus 中
      this.editor.config.menus = this.editor.config.menus.concat('addImage')
      this.editor.config.menus = this.editor.config.menus.concat('addTable')
      this.editor.config.menus = this.editor.config.menus.concat('AddVideo')
      this.editor.config.menus = this.editor.config.menus.concat('AddFile')
    },
    /**
     * 动态挂载组件
     * @param Component {Vue|VNode} 组件名称
     * @param props {object} 组件参数
     * @returns {Vue|VNode}
     */
    mountComponent(Component, props) {
      const vm = new Vue({
        render(h) {
          return h(Component, { props })
        },
      }).$mount()
      const container = document.getElementById('editor__body').getElementsByTagName('div')[0]
      container.appendChild(vm.$el)
      const comp = vm.$children[0]
      comp.remove = () => {
        container.removeChild(vm.$el)
        vm.$destroy()
      }
      return comp
    },
    /**
     * 限制条件下寻找dom元素的根节点
     * @param elem {} dom节点
     */
    handleFindRangeRoot(elem) {
      if (elem?.parentNode?.className?.includes('w-e-text')) {
        this.rangeRoot = elem
        return
      }
      this.handleFindRangeRoot(elem?.parentNode)
    },
    /**
     * 插入自定义元素前的处理逻辑
     * @param elem {} 待插入dom元素
     */
    beforeInsertElement(elem) {
      // 在光标处插入包装好的自定义组件
      const range = this.editor.selection.getRange()
      if (range == null) {
        return
      }
      // 获取光标所在节点
      const node = range?.commonAncestorContainer
      // 寻找光标所在的节点的祖先根几点
      this.handleFindRangeRoot(node)
      // 向后插入兄弟元素
      this.insertAfter(elem)
    },
    /**
     * 向后插入兄弟元素
     * @param newElement {} 待插入的元素
     */
    insertAfter(newElement) {
      const parent = this.rangeRoot?.parentNode
      if (parent.lastChild === this.rangeRoot) {
        parent.appendChild(newElement)
      } else {
        parent.insertBefore(newElement, this.rangeRoot?.nextSibling)
      }
      // 插入元素之后，换行显示光标
      const p = document.createElement('p')
      p.innerHTML = '</br>'
      parent.appendChild(p)
      this.placeCaretAtEnd(p)
      this.rangeRoot = void 0
    },
    // 传入光标要去的jq节点对象
    placeCaretAtEnd(el) {
      el.focus()
      if (
        typeof window.getSelection !== 'undefined'
        && typeof document.createRange !== 'undefined'
      ) {
        const range = document.createRange()
        range.selectNodeContents(el)
        range.collapse(false)
        const sel = window.getSelection()
        sel.removeAllRanges()
        sel.addRange(range)
      } else if (typeof document.body.createTextRange !== 'undefined') {
        const textRange = document.body.createTextRange()
        textRange.moveToElementText(el)
        textRange.collapse(false)
        textRange.select()
      }
    },
    /**
     * 包装自定义组件组件
     * @param elem
     * @param componnetType {string} 自定义组件类型： 'TABLE'、'IMAGE'、'VIDEO'
     */
    packageDOMElement(elem, componnetType) {
      // 创建包装盒
      const div = document.createElement('div')
      div.id = new Date().getTime().toString()
      div.contentEditable = 'false'
      div.className = 'area__container'
      div.appendChild(elem)

      // 包装操作
      this.packageData(div, componnetType)
      this.packageEvent(div, componnetType)
      this.packageCompleted(div, componnetType)
      this.beforeInsertElement(div)
    },
    /**
     * 包装自定义组件数据
     * @param elem {} DOM元素
     * @param type {string} DOM元素类型
     */
    packageData(elem, type) {
      const el = elem
      switch (type) {
        case 'TABLE':
          el.dataset.data = JSON.stringify({
            type,
            data: {
              thead: this.tableHeader,
              tbody: [...this.tableData],
            },
          })
          break
        default: {
          //
        }
      }
    },
    /**
     * 包装自定义组件事件
     * @param elem {} DOM元素
     * @param type {string} DOM元素类型
     */
    packageEvent(elem, type) {
      _this = this
      const el = elem
      switch (type) {
        case 'TABLE':
          el.ondblclick = function monitorOndblclick() {
            _this.selectedAreaId = el.id
            const { data } = JSON.parse(el.dataset.data)
            _this.tableMode = 'EDIT'
            _this.dialogTableVisible = true
            _this.tableData = []
            for (const item of data.tbody) {
              _this.tableData.push(item)
            }
            _this.tableHeader = data.thead
            _this.$nextTick(() => {
              document.querySelector('.table_header__input').value = data.thead
            })
          }
          break
        default: {
          //
        }
      }
    },
    /**
     * 包装自定义组件结束后执行的逻辑
     * @param elem {} DOM元素
     * @param type {string} DOM元素类型
     */
    packageCompleted(elem, type) {
      switch (type) {
        case 'TABLE':
          this.tableHeader = ''
          this.tableData = []
          this.dialogTableVisible = false
          break
        default: {
          //
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../css/common.scss';
@import '../../css/editor.scss';
.fill {
  background: $colorBgLevel3;
  border: 1px solid $colorBorderLevel3;
}

::v-deep .ant-affix {
  z-index: 20;
  border-top: 1px solid $colorBorderLevel3;
  border-bottom: 1px solid $colorBorderLevel3;
  height: 46px !important;
}

#editor__header {
}

#editor__body {
  min-height: calc(100%);
  overflow: auto;
}

.table-cell {
}

.table-cell__operate {
  padding: 0 16px;
  background: $colorBgLevel3;
}

.table-icon {
  height: 36px;
  width: 28px;
  margin-right: 8px;
  background: $colorBgLevel3;
}

::v-deep .w-e-toolbar .w-e-menu {
  height: 30px;
  width: 30px;
}

::v-deep .el-table td,
::v-deep .el-table th {
  padding: 0 !important;
}

::v-deep .el-table .cell {
  padding: 0;
}

::v-deep .el-table .cell,
.el-table--border td:first-child .cell,
.el-table--border th:first-child .cell {
  padding-left: 0 !important;
}

::v-deep .el-input__inner {
  border-radius: 0;
  border: 0;
}

::v-deep .el-table th .el-input__inner {
  background: $colorBgLevel2;
}

.el-table .cell .table-cell {
  border-right: 1px solid $colorBorderLevel3;
}

.el-table .cell .table-cell:last-child {
  border-right: 0;
}

::v-deep .el-switch__core {
  background: $colorSecondaryActive;
  border: 1px solid $colorSecondaryActive;
}

::v-deep .el-switch.is-checked .el-switch__core {
  border-color: $colorPrimary;
  background-color: $colorPrimary;
}

::v-deep .el-switch__label {
  color: $colorFontLevel3 !important;
}

::v-deep .el-switch__label.is-active {
  color: $colorPrimary !important;
}

::v-deep .el-button--primary.is-plain {
  color: $colorStatePrimary !important;
  background: $colorDefault !important;
  border-color: $colorStatePrimary !important;
}

::v-deep .el-button--primary.is-plain:active {
  color: $colorStatePrimary !important;
  background: $colorDefaultActive !important;
  border-color: $colorStatePrimary !important;
}

::v-deep .el-button--primary.is-plain:hover {
  color: $colorStatePrimary !important;
  background: $colorDefaultHover !important;
  border-color: $colorStatePrimary !important;
}

::v-deep .el-dialog__body {
  padding: 24px;
}

::v-deep .el-dialog__header {
  font-weight: 400;
  color: $colorFontLevel1;
  background: $colorBgLevel2;
  padding: 1em 2em !important;
}
::v-deep .el-dialog__header .el-dialog__title {
  font-size: 16px !important;
}

::v-deep .el-dialog__headerbtn .el-dialog__close {
  color: $colorFontLevel1;
  font-weight: 700;
}

::v-deep .el-dialog__headerbtn:focus .el-dialog__close,
::v-deep .el-dialog__headerbtn:hover .el-dialog__close {
  color: $colorFontLevel1;
  font-weight: 700;
}

#range {
  position: relative;
}

#range::after {
  position: absolute;
  content: '';
  display: inline-block;
  width: 2px;
  height: 18px;
  top: 50%;
  transform: translateY(-50%);
  animation: blink 1.2s infinite steps(1, start);
}

@keyframes blink {
  0%,
  100% {
    background-color: #000000;
  }
  50% {
    background-color: transparent;
  }
}

#image-uploader ::v-deep .el-dialog {
  width: fit-content;
}

.uploader__image {
  width: 630px;
  height: 330px;
  overflow: auto;
}
::v-deep table {
  padding: 0 !important;
}
::v-deep .el-button--small {
  font-weight: 500 !important;
  font-size: 14px;
}
.uploader__file {
  height: 400px;
}
::v-deep .el-icon-files {
  font-weight: 700;
}
.table_header__input {
  width: 100%;
  background: #f5f5f5;
  border-radius: 0;
  border: 0;
  font-size: 14px;
  font-weight: 400;
  padding: 15px 18px;
  color: #222222;
  outline: 0;
}
::v-deep .w-e-text-container {
  height: calc(100vh - 275px) !important;
  padding-bottom: 100px !important;
}
</style>

<style lang="scss"></style>
